export const ROUTE_CREAR_REQUERIMIENTO_IMP = 'importacion:crear-requerimiento'
export const ROUTE_GESTION_REQUERIMIENTOS_IMP = 'importacion:gestion-requerimiento'
export const ROUTE_BANDEJA_GASTO_IMPORTACION = 'importacion:bandeja-gasto-importacion'
export const ROUTE_GASTO_IMPORTACION = 'importacion:gasto-importacion'
export const ROUTE_BANDEJA_APROBACION_REQUERIMIENTO_IMP = 'importacion:bandeja-aprobacion'
export const ROUTE_NACIONALIZACION_IMPORTACION = 'importacion:nacionalizacion-importacion'
export const ROUTE_GESTION_DISTRIBUCION_IMPORTACION = 'importacion:bandeja-distribucion-importacion'
export const ROUTE_DISTRIBUCION_IMPORTACION = 'importacion:distribucion-importacion'
export const ROUTE_RECEPCION_IMPORTACION = 'importacion:recepcion-importacion'
export const ROUTE_CIERRE_IMPORTACION = 'importacion:cierre'
export const ROUTE_GESTION_LIQUIDACION_IMP = 'importacion:gestion-liquidacion'
export const ROUTE_LIQUIDACION_IMPORTACION = 'importacion:liquidacion-importacion'
export const ROUTE_APROBACION_LIQUIDACION_IMP = 'importacion:aprobacion-liquidacion'
export const ROUTE_REVISION_LIQUIDACION = 'importacion:revision-liquidacion'
export const ROUTE_ASIGNACION_GASTO_IMPORTACION = 'importacion:asignacion-gasto-importacion'
export const ROUTE_BANDEJA_PENDIENTE_NACIONALIZAR = 'importacion:pendiente-nacionalizar'
